import React from "react";
import AuthUserContext from "./AuthUserContext.js";

export default function useAuthUser() {
  return React.useContext(AuthUserContext);
}
